import styles from "./index.module.scss";
import StubNotificationForm from "./stubNotificationForm";

export default function StubPage({ stub }: any) {
  const displayModelName = [stub.markName, stub.modelName, stub.kuzovName]
    .filter(Boolean)
    .join(" ");

  return (
    <div>
      <div className={styles.TopText}>
        <p>
          Поздравляем с выбором нового <strong>{displayModelName}</strong>!
          Идеальный фаркоп для данного автомобиля еще находится в разработке у
          производителей.
        </p>
      </div>

      <div className={styles.FormSection}>
        <h2 className={styles.FormTitle}>
          Хотите узнать о поступлении первым и получить выгодную цену?
        </h2>
        <p className={styles.FormDescription}>
          Как только фаркопы на{" "}
          <strong>{displayModelName || "выбранную модель"}</strong> появятся, мы
          сразу же сообщим Вам об этом по телефону или e-mail.
        </p>
        <StubNotificationForm />
      </div>
    </div>
  );
}
